import { WebglSettingsConverter } from "./webgl-settings-converter";

export class ViewWebglSettingsConverter extends WebglSettingsConverter {
  constructor(canvasWebglSettingsConverter) {
    super();
    this.canvasWebglSettingsConverter = canvasWebglSettingsConverter;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    settingsCopy.canvas = this.canvasWebglSettingsConverter.convert(settings.canvas);
    return settingsCopy;
  }
}
